import types from '../actions/types';

const initialState = {
  clientes: null,
  tickets: null,
  vendedor: null,
  isFetching: false,
  configuracion: null,
  hasError: false,
  errorMessage: '',
  clienteCobrar: null,
  printer: '',
};

export default ( state = initialState, action ) => {
  switch ( action.type ) {
    case types.VENDEDOR_LOGIN:
      {
        const { email, login, uid, numero_vendedor, vendedor_nombre, VKBUR, VKORG } = action.payload;
        return {
          ...state,
          vendedor: {email, login, uid, numero_vendedor, vendedor_nombre, VKBUR, VKORG }
        };
      }
    case types.TICKETS_FETCHING:
      {
        const { tickets } = action.payload;
        return {
          ...state,
          tickets
        };
      }
    case types.CLIENTE_COBRAR:
      {
        const { clienteCobrar } = action.payload;
        return {
          ...state,
          clienteCobrar
        };
      }
    case types.TICKETS_ADD:
      {
        const { ticket } = action.payload;
        return {
          ...state,
          tickets: state.tickets.concat(ticket)
        };
      }
    case types.TICKETS_UPDATE:
      {
        const { ticket } = action.payload;
        return {
          ...state,
          tickets: ticket
        };
      }
    case types.CONFIGURACION_FETCHING:
      {
        const { configuracion } = action.payload;
        return {
          ...state,
          configuracion
        };
      }
    case types.FETCHING_START:
      {
        return {
          ...state,
          isFetching: true
        };
      }
    case types.FETCHING_END:
      {
        return {
          ...state,
          isFetching: false
        };
      }
    case types.CLIENTES_FETCHING:
      {
        const { clientes } = action.payload;
        return {
          ...state,
          clientes
        };
      }
    case types.RESET_ALL_DATA:
      {
        return { ...initialState };
      }
    case types.RESET_DATA:
        {
          return { 
            ...state,
            clientes: [],
            tickets: [],
            configuracion: []
          };
        }
    case types.PRINTER_ADD:
      {
        const { printer } = action.payload;
        return { 
          ...state,
          printer
        };
      }
      case types.PRINTER_RESET:
        {
          return { 
            ...state,
            printer: ''
          };
        }
    default:
      {
        return state;
      }
  }
};